<template>
    <div class="advertBox">
        <div class="search">
            <el-input v-model="keyWord" placeholder="请输入站点名称" size="normal" clearable>
                <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
        </div>
        <div class="buttons">
            <el-button size="default" icon="el-icon-plus" @click="add">新增广告</el-button>
        </div>
        <div class="content">
            <mu-load-more @refresh="refresh" :refreshing="refreshing" :loaded-all="loaded_all" :loading="loading"
                @load="load">
                <el-card shadow="always" v-for="(item, index) in advertList" :key="index">
                    <div class="header">
                        <img :src="item.fileUrl" alt="" style="width: 2.7778rem;height:2.0833rem;">
                        <div class="info">
                            <div class="headerTitle">
                                {{ item.title }}
                            </div>
                            <div>
                                <span>链接:</span>
                                <span>{{ item.url }}</span>
                            </div>
                            <div>
                                <span>{{ item.showPage }}</span>
                            </div>
                        </div>
                        <div class="itemButton">
                            <el-button size="default" @click="edit(item)" round>编辑</el-button>
                            <el-button size="default" @click="del(item.id)" round>删除</el-button>
                        </div>
                    </div>
                </el-card>
                <div v-show="nolist" class="nolist">
                    <span class="iconfont icon-charging"></span>
                    <p>暂无广告记录</p>
                </div>
            </mu-load-more>
        </div>
    </div>
</template>
<script>
import { getAdvertList,delAdvert } from '@/api/newApi'
import { Toast } from "vant";
import "vant/lib/toast/style/index";
export default {
    data() {
        return {
            from: {
                pageSize: 10,
                pageNo: 1,
            },
            keyWord: "",
            advertList: [],
            nolist: true,
            token: "",
            refreshing: false,
            loaded_all: false,
            loading: false,
        }
    },
    watch: {
        keyWord: function () {
            this.getList();
        },
        advertList: function (v) {
            if (v == "") {
                this.nolist = true;
            } else {
                this.nolist = false;
            }
        }
    },
    mounted() {
        this.getList()
    },
    methods: {
        getList() {
            console.log(this.from);
            getAdvertList({
                title: this.keyWord,
                ...
                this.from
            }).then((res) => {
                console.log(res);
                this.advertList = res.data.records
                this.nolist = false;
                if (res.data.pages == 1) {
                    // Toast("已加载全部数据");
                    this.loaded_all = true;
                }
                this.refreshing = false;
            }).catch((res) => {
                console.log(res);
            })
        },
        load() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                this.from.pageSize += 3;
                this.getList();
            }, 2000);
        },
        refresh() {
            this.refreshing = true;
            this.$refs.container.scrollTop = 0;
            setTimeout(() => {
                this.refreshing = false;
                this.getList();
            }, 2000);
        },
        edit(item){
            this.$router.push({
                path:"/admin/addAdvert",
                query:item,
            })
        },
        add() { 
            this.$router.push({
                path:"/admin/addAdvert"
            })
        },
        del(id){
            delAdvert({id:id}).then(res=>{
                if(res.message.status == 200){
                    Toast("删除成功")
                    this.getList();
                }
            })
        }
    },
}
</script>
<style lang="scss" scoped>
@import"@/assets/sass/state.scss";

.advertBox {
    padding: .4167rem;
    .buttons{
        margin: .4167rem 0 0 0;
    }
    .header {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        
        .itemButton,.info {
            display: flex;
            flex-direction: column;
            justify-content: space-around;

            ::v-deep .el-button {
                padding: .1667rem .4167rem;
                margin-left: 0;
            }
        }
        .info{
            width: calc(100% - 2.7778rem - 1.6667rem);
            >div{
                margin-left: .1389rem;
                color: #7E85A7;
            }
        }
    }
    .content {
        ::v-deep .el-card{
            margin: .4167rem 0;
        }
    }
    ::v-deep .el-input__inner{
        background-color: #0D1A3C;
        border: 1px solid transparent;
    }
}
</style>